/**
 * @deprecated
 * DO NOT USE. Exists for legacy style calculations.
 * For padding/margin/top/bottom/left/right use space tokens.
 * For width/height use hardcoded values.
 */
export const GRID_SIZE = 8;
